import { DEFAULT_SORT_ATTRIBUTE, SortOrderEnum } from "./constants"

export class SelectedSortingAttributeManager {
  constructor(
    sortingAttribute,
    sortingOrder
  ) {
    this.sortingAttribute = sortingAttribute
    this.sortingOrder = sortingOrder
  }

  static default() {
    return new SelectedSortingAttributeManager(DEFAULT_SORT_ATTRIBUTE, null);
  }

  getSelectedSortingAttribute() {
    return this.sortingAttribute;
  }

  getSelectedSortingOrder() {
    return this.sortingOrder
  }

  setSelectedSortingAttribute(
    sortingAttribute
  ) {
    if (sortingAttribute === DEFAULT_SORT_ATTRIBUTE) {
      return new SelectedSortingAttributeManager(sortingAttribute, null);
    } else {
      return new SelectedSortingAttributeManager(
        sortingAttribute,
        SortOrderEnum.Desc
      );
    }
  }

  setSelectedSortingOrder(
    sortingOrder
  ) {
    return new SelectedSortingAttributeManager(
      this.sortingAttribute,
      sortingOrder
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Kendra/sorting/SelectedSortingAttributeManager.js